import {Box, CircularProgress} from "@mui/material"
import React from "react"

/** Convenient stabilizer for consistent loading spinner sizes */
export const CircularProgressSize = {
    SMALL: 20,
    MEDIUM: 40,
    LARGE: 80
} as const;

/** Type which indicates the possible values of CircularProgressSize */
export type CircularProgressSize = typeof CircularProgressSize[keyof typeof CircularProgressSize]

export const AvantCircularProgress = ({size}: { size?: CircularProgressSize }) => (
    <Box style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
    }}>
        <CircularProgress size={size ?? CircularProgressSize.LARGE}/>
    </Box>
)
